<a class="auction-card" [routerLink]="'/auctions/' + data()._id">
  <div class="auction-card__media">
    <img
      class="auction-card__image"
      [ngSrc]="
        data()?.product?.images?.[0]?.cropped_url?.toLowerCase() ||
          data()?.product?.images?.[0]?.url | imageSource
      "
      [alt]="data()?.title | translateData"
      width="400"
      height="267" />

    @if (endsInLabel) {
      <span class="auction-card__countdown">
        <i class="auction-card__countdown-icon iconsax" icon-name="clock"></i>
        {{ 'home.auctionsSection.endsIn' | translate }}: {{ endsInLabel }}
      </span>
    }
  </div>

  <div class="auction-card__body">
    <h3 class="auction-card__title">
      <pwj-text-summarizer [limitLength]="48" [text]="data().title | translateData">
      </pwj-text-summarizer>
    </h3>

    <div class="auction-card__divider" aria-hidden="true"></div>

    <div class="auction-card__footer">
      <div class="auction-card__price-block">
        <span class="auction-card__price-label">{{
          'home.auctionsSection.currentBid' | translate
        }}</span>
        <div class="auction-card__price-row">
          <span class="auction-card__price-value">
            {{ currencyToSymbol(data()?.currency) }}
            {{ currentBidPrice | number }}
          </span>
        </div>
      </div>
      <span class="auction-card__cta">{{ 'home.auctionsSection.placeBid' | translate }}</span>
    </div>
  </div>
</a>
